import { render, staticRenderFns } from "./SocialMediaFacebookInstagram.vue?vue&type=template&id=4f9d1169&"
import script from "./SocialMediaFacebookInstagram.vue?vue&type=script&lang=js&"
export * from "./SocialMediaFacebookInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports